
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"#55A3FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.359 0H5.64C2.256 0 0 2.42 0 5.893v8.214C0 17.583 2.25 20 5.641 20h8.718C17.75 20 20 17.583 20 14.107V5.893C20 2.417 17.75 0 14.359 0zM5.64 1.395h8.718c2.597 0 4.246 1.77 4.246 4.498v8.214c0 2.727-1.649 4.498-4.246 4.498H5.64c-2.597 0-4.246-1.77-4.246-4.498V5.893c0-2.724 1.654-4.498 4.246-4.498zM10 5.885c.353 0 .645.263.691.604l.007.095v2.71h2.713a.698.698 0 01.095 1.388l-.095.007h-2.713v2.71a.698.698 0 01-1.39.094l-.006-.094v-2.71H6.59a.698.698 0 01-.095-1.39l.095-.006h2.713v-2.71c0-.385.313-.697.698-.697z","fill":"inherig"}})])
          )
        }
      }
    